import CustomerScreen from './index';

const routes = [
  {
    path: '/onboarding-customer',
    component: CustomerScreen,
  },
];

export default routes;
